export type ChoicesStringListEntry = string | boolean | null | undefined;

export type ChoicesStringListValue = ChoicesStringListEntry[] | ChoicesStringListEntry;

export type ChoicesInstance = {
    destroy?: () => void;
    setChoiceByValue?: (value: string) => void;
    removeActiveItems?: () => void;
    hideDropdown?: () => void;
    showDropdown?: () => void;
    dropdown?: { isActive?: boolean } | null;
    containerOuter?: { element?: HTMLElement | null };
};

export type ChoicesSelectInternals = HTMLSelectElement & {
    __choicesInstance?: ChoicesInstance;
    __choicesTranslatePlaceholderHandler?: EventListener;
    __choicesControlUpdateUiStateHandler?: EventListener;
    __choicesControlSyncHandler?: EventListener;
    __choicesControlClearHandler?: EventListener;
    __choicesControlToggleHandler?: EventListener;
    __choicesControlToggleCapture?: boolean;
    __choicesControlShowDropdownHandler?: EventListener;
};

export class ChoicesControlUtils {
    public static asInternalSelect(select: HTMLSelectElement): ChoicesSelectInternals {
        return select as ChoicesSelectInternals;
    }

    public static normalizeStringList(value: ChoicesStringListValue): string[] {
        if (value === null || value === undefined) return [];

        if (Array.isArray(value)) {
            return Array.from(new Set(value.map((entry) => String(entry).trim()).filter(Boolean)));
        }

        const raw = String(value).trim();
        if (!raw) return [];

        if (raw.startsWith("[") && raw.endsWith("]")) {
            try {
                const decoded = JSON.parse(raw);
                if (Array.isArray(decoded)) {
                    return Array.from(new Set(decoded.map((entry) => String(entry).trim()).filter(Boolean)));
                }
            } catch {
                // fall back to CSV
            }
        }

        return Array.from(
            new Set(
                raw
                    .split(",")
                    .map((entry) => entry.trim())
                    .filter(Boolean),
            ),
        );
    }
}
